/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */
let baseUrl; 
let routerMode;
let ssoUrl;
let wechatUrl;
let cdoUrl;
let appUrl;
let cvoUrl;
let endpoint;
let cdnUrl;
let uploadRedirect;
const imgBaseUrl = 'https://fuss10.elemecdn.com';

if (process.env.VUE_APP_INNERNODE_ENV == 'development') {

	baseUrl = 'https://qa.doterrahk.com';
	// baseUrl = 'http://localhost:8888'
	wechatUrl = 'https://wxqa.doterra.cn';
	// cdoUrl = 'https://cdoqa.doterra.cn';
	// cdoUrl = 'http://localhost:55595'
	ssoUrl = "https://ssoqa.doterra.cn";
	// appUrl = "https://appqa.doterra.cn"
	cvoUrl = "https://cvoqa.doterra.cn"
	// cvoUrl = "http://localhost:55595"
	endpoint = 'https://docstage.doterra.cn/files';
	uploadRedirect = 'https://cdnstage.dohwg.cn/images';
	cdnUrl = 'https://cdnstage.dohwg.cn/images/do'
	routerMode = 'hash'
}else if (process.env.VUE_APP_INNERNODE_ENV == 'qa') {
	baseUrl = 'https://qa.doterrahk.com';
	wechatUrl = 'https://wxqa.doterra.cn';
	cdoUrl = 'https://cdoqa.doterra.cn';
	ssoUrl = "https://ssoqa.doterra.cn";
	appUrl = "https://appqa.doterra.cn"
	cvoUrl = "https://cvoqa.doterra.cn"
	endpoint = 'https://docstage.doterra.cn/files';
	uploadRedirect = 'https://cdnstage.dohwg.cn/images';
	cdnUrl = 'https://cdnstage.dohwg.cn/images/do'
	routerMode = 'hash'
	
} else {
	baseUrl = 'https://shop.doterrahk.com';
	wechatUrl = 'https://wx.doterra.cn';
	cdoUrl = 'https://cdo.doterra.cn';
	ssoUrl = "https://sso.doterra.cn";
	appUrl = "https://app.doterra.cn"
	cvoUrl = "https://cvo.doterra.cn"
	endpoint = 'https://doc.doterra.cn/files';
	uploadRedirect = 'https://hkprodcdn.dohwg.cn/images';
	cdnUrl = 'https://hkprodcdn.dohwg.cn/images/do'
	routerMode = 'hash'
	
}

export {
	endpoint,
	uploadRedirect,
	baseUrl,
	wechatUrl,
	cdoUrl,
	ssoUrl,
	routerMode,
	imgBaseUrl,
	appUrl,
	cvoUrl,
	cdnUrl,
}